import { useCallback } from "react";

import { getRoomDetailUrl } from "@/lib/chillnn/get-detail-url";

import { useProductRoomFormModelContext } from "../../../../../_shared/context";
import { useProductNewRoomFormModelContext } from "../../../../context";

export const useActions = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { onUpdate } = useProductNewRoomFormModelContext();

	const { hasError, isDirty, inSale, hotelID, roomID } = viewModel;
	const isValid = !hasError && isDirty;

	const handleChangeInSale = useCallback(
		(_input: boolean | undefined) => {
			if (inSale.value) {
				// 公開中なので、非公開にする
				onSetViewModel([
					{
						key: "inSale",
						value: {
							isEdited: false,
							value: false,
						},
					},
				]);
			} else {
				// 非公開中なので、公開にする
				onSetViewModel([
					{
						key: "inSale",
						value: {
							isEdited: true,
							value: true,
						},
					},
				]);
			}
		},
		[inSale.value, onSetViewModel],
	);

	const handleClickPreviewButton = useCallback(() => {
		onUpdate();

		const url = getRoomDetailUrl(hotelID, roomID);
		window.open(url, "_blank");
	}, [hotelID, onUpdate, roomID]);

	return {
		isValid,
		onUpdate,

		// 公開非公開に関するプロパティ
		inSale,
		handleChangeInSale,

		// プレビューに関するプロパティ
		handleClickPreviewButton,
	};
};
